(function () {
  const STORAGE_KEY = 'ssj-wholesale-quote-v1';

  function readQuote() {
    try {
      const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function writeQuote(items) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    renderQuote();
  }

  function quoteText(items) {
    if (!items.length) return 'No products have been added yet.';
    return items
      .map(function (item, index) {
        return [
          index + 1 + '. ' + item.product,
          'Variant: ' + item.variant,
          'Quantity: ' + item.quantity,
          'Displayed item price: ' + item.price,
          'Product URL: ' + item.url,
        ].join('\n');
      })
      .join('\n\n');
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function renderQuote() {
    const items = readQuote();
    const summary = document.querySelector('[data-ssj-quote-summary]');
    const textarea = document.getElementById('SSJQuoteItems');
    const countNodes = document.querySelectorAll('[data-ssj-quote-count]');

    countNodes.forEach(function (node) {
      node.textContent = String(items.reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0));
    });

    if (textarea) textarea.value = quoteText(items);
    if (!summary) return;

    if (!items.length) {
      summary.innerHTML = '<p>Your quote list is empty. Browse products and choose <strong>Add to Quote</strong>.</p>';
      return;
    }

    summary.innerHTML = items
      .map(function (item, index) {
        const image = item.image
          ? '<img class="ssj-quote-item__image" src="' + escapeHtml(item.image) + '" alt="" loading="lazy">'
          : '';
        return (
          '<div class="ssj-quote-item">' +
          image +
          '<div class="ssj-quote-item__details"><strong>' + escapeHtml(item.product) + '</strong>' +
          '<span>' + escapeHtml(item.variant) + ' &middot; Qty ' + escapeHtml(String(item.quantity)) + '</span></div>' +
          '<button type="button" data-ssj-remove-quote="' + index + '">Remove</button>' +
          '</div>'
        );
      })
      .join('');
  }

  document.addEventListener('click', function (event) {
    const addButton = event.target.closest('[data-ssj-add-quote]');
    if (addButton) {
      const form = addButton.closest('[data-ssj-product-form]');
      const select = form && form.querySelector('[data-ssj-variant]');
      const quantityInput = form && form.querySelector('[data-ssj-quantity]');
      const selected = select && select.options[select.selectedIndex];
      const quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);
      const item = {
        product: addButton.dataset.productTitle || '',
        variant: selected ? selected.textContent.trim() : 'Default',
        variantId: selected ? selected.value : '',
        quantity: quantity,
        price: selected && selected.dataset.price ? selected.dataset.price : addButton.dataset.productPrice || '',
        url: addButton.dataset.productUrl || window.location.href,
        image: addButton.dataset.productImage || '',
      };
      const items = readQuote();
      const existing = items.find(function (entry) {
        return entry.variantId === item.variantId && entry.url === item.url;
      });

      if (existing) {
        existing.quantity += quantity;
        existing.image = existing.image || item.image;
      } else {
        items.push(item);
      }

      writeQuote(items);
      addButton.textContent = 'ADDED TO QUOTE';
      window.setTimeout(function () {
        addButton.textContent = 'ADD TO QUOTE';
      }, 1600);
      return;
    }

    const removeButton = event.target.closest('[data-ssj-remove-quote]');
    if (removeButton) {
      const items = readQuote();
      items.splice(Number(removeButton.dataset.ssjRemoveQuote), 1);
      writeQuote(items);
      return;
    }

    const successClose = event.target.closest('[data-ssj-close-success]');
    if (successClose) {
      const modal = successClose.closest('.ssj-success-modal');
      if (modal) modal.remove();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const modal = document.querySelector('.ssj-success-modal');
    if (modal) modal.remove();
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.ssj-success-modal')) {
      window.localStorage.removeItem(STORAGE_KEY);
    }
    renderQuote();
  });
  document.addEventListener('shopify:section:load', renderQuote);
})();

(function () {
  function initializeSlider(slider) {
    if (!slider || slider.dataset.ssjReady === 'true') return;

    const slides = Array.from(slider.querySelectorAll('[data-ssj-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-ssj-slide-dot]'));
    const previous = slider.querySelector('[data-ssj-slide-prev]');
    const next = slider.querySelector('[data-ssj-slide-next]');
    let current = 0;
    let timer;

    if (slides.length < 2) return;
    slider.dataset.ssjReady = 'true';

    function show(index, restart) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        const isActive = slideIndex === current;
        slide.hidden = !isActive;
        slide.classList.toggle('ssj-slide--active', isActive);
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === current);
        dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
      });
      if (restart) startTimer();
    }

    function startTimer() {
      window.clearInterval(timer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function () { show(current + 1, false); }, 6500);
    }

    if (previous) previous.addEventListener('click', function () { show(current - 1, true); });
    if (next) next.addEventListener('click', function () { show(current + 1, true); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { show(Number(dot.dataset.ssjSlideDot), true); });
    });
    slider.addEventListener('mouseenter', function () { window.clearInterval(timer); });
    slider.addEventListener('mouseleave', startTimer);
    show(0, false);
    startTimer();
  }

  function initializeAllSliders() {
    document.querySelectorAll('[data-ssj-slider]').forEach(initializeSlider);
  }

  document.addEventListener('DOMContentLoaded', initializeAllSliders);
  document.addEventListener('shopify:section:load', initializeAllSliders);
})();
